import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout as StripeEmbeddedCheckout,
} from '@stripe/react-stripe-js';
import { STRIPE_PUBLISHABLE_KEY } from '../lib/env';

interface EmbeddedCheckoutProps {
  clientSecret: string;
  onClose?: () => void;
}

const stripePromise = STRIPE_PUBLISHABLE_KEY ? loadStripe(STRIPE_PUBLISHABLE_KEY) : null;

const EmbeddedCheckout: React.FC<EmbeddedCheckoutProps> = ({ clientSecret, onClose }) => {
  if (!stripePromise || !STRIPE_PUBLISHABLE_KEY) {
    return (
      <div className="text-center py-8">
        <p className="text-red-600">Stripe is not configured. Please contact support.</p>
        {onClose && (
          <button onClick={onClose} className="btn-secondary mt-4">
            Close
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="w-full">
      <EmbeddedCheckoutProvider
        stripe={stripePromise}
        options={{
          clientSecret,
          onComplete: () => {
            console.log('[EmbeddedCheckout] Payment completed!');
            // Stripe will redirect to success_url automatically
            // We can add additional tracking here if needed
          },
        }}
      >
        <StripeEmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
};

export default EmbeddedCheckout;
